module.exports = __webpack_public_path__ + "loading.07adbca8c700ba1be5f1.gif";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/img/loading.gif
// module id = ../../../../../src/assets/img/loading.gif
// module chunks = main